import { ENV_VARS } from '@/env';
import { Col, Row } from 'antd';
import { isEqual } from 'es-toolkit';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { NumericFormat } from 'react-number-format';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ReactComponent as WarningIcon } from '../../../../assets/icons/alert-exclamtion.svg';
import { ReactComponent as DashboardIcon } from '../../../../assets/icons/dashboard-icon.svg';
import { ReactComponent as DocumentWarningIcon } from '../../../../assets/icons/document-warning.svg';
import { ReactComponent as FilesIcon } from '../../../../assets/icons/files-records.svg';
import { ReactComponent as LateDeliveryIcon } from '../../../../assets/icons/late-delivery.svg';
import { ReactComponent as OpenboxIcon } from '../../../../assets/icons/open-box.svg';
import { ReactComponent as TrackingFailedIcon } from '../../../../assets/icons/tracking-failed.svg';
import { routeFileSelector } from '../../../../utilz/i18n';
import VerticalLine from '../../../components/Bars/VerticalLine';
import IconButton from '../../../components/Buttons/IconButton';
import FooterContentCard from '../../common/FooterContentCard';

const ShipmentFooter = () => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);
  const { totalRecords, awarded, cancelled, internalReview, openForBid, readyForAward } = useSelector(
    (state) => state.shipment.quoteSearchList,
    (a, b) => isEqual(a.totalRecords, b.totalRecords),
  );

  return (
    <div className="">
      <Row
        justify="space-around"
        className={`${
          ENV_VARS.REACT_APP_THEME === 'halliburton' ? 'hb-bg-color' : ''
        } footer-container background-header px-20  py-12`}
      >
        <Col data-testid="search-quote-footer-totalRecords">
          <FooterContentCard
            count={
              <NumericFormat
                thousandsGroupStyle="lakh"
                displayType="text"
                value={String(totalRecords)}
                thousandSeparator
              />
            }
            label={t('translation:searchQuote.footer.totalRecords')}
            Icon={FilesIcon}
          />
        </Col>
        <Col>
          <VerticalLine />
        </Col>
        <Col data-testid="search-quote-footer-internalReview">
          <FooterContentCard
            count={
              <NumericFormat
                thousandsGroupStyle="lakh"
                displayType="text"
                value={String(internalReview)}
                thousandSeparator
              />
            }
            label={t('translation:searchQuote.footer.internalReview')}
            Icon={DocumentWarningIcon}
          />
        </Col>
        <Col>
          <VerticalLine />
        </Col>
        <Col data-testid="search-quote-footer-openForBid">
          <FooterContentCard
            count={
              <NumericFormat
                thousandsGroupStyle="lakh"
                displayType="text"
                value={String(openForBid)}
                thousandSeparator
              />
            }
            label={t('translation:searchQuote.footer.openForBid')}
            Icon={OpenboxIcon}
          />
        </Col>
        <Col>
          <VerticalLine />
        </Col>
        <Col data-testid="search-quote-footer-readyForAward">
          <FooterContentCard
            count={
              <NumericFormat
                thousandsGroupStyle="lakh"
                displayType="text"
                value={String(readyForAward)}
                thousandSeparator
              />
            }
            label={t('translation:searchQuote.footer.readyForAward')}
            Icon={TrackingFailedIcon}
          />
        </Col>
        <Col>
          <VerticalLine />
        </Col>
        <Col data-testid="search-quote-footer-awarded">
          <FooterContentCard
            count={
              <NumericFormat thousandsGroupStyle="lakh" displayType="text" value={String(awarded)} thousandSeparator />
            }
            label={t('translation:searchQuote.footer.awarded')}
            Icon={LateDeliveryIcon}
          />
        </Col>
        <Col>
          <VerticalLine />
        </Col>
        <Col data-testid="search-quote-footer-cancelled">
          <FooterContentCard
            count={
              <NumericFormat
                thousandsGroupStyle="lakh"
                displayType="text"
                value={String(cancelled)}
                thousandSeparator
              />
            }
            label={t('translation:searchQuote.footer.cancelled')}
            Icon={WarningIcon}
          />
        </Col>
        <Col>
          <VerticalLine />
        </Col>
        <Col className="d-flex">
          <IconButton>
            <DashboardIcon />
          </IconButton>
        </Col>
      </Row>
    </div>
  );
};

export default memo(ShipmentFooter);
